export enum AnimationDismissType {
    FloatingButton = 1,
    FadeOut = 2
}
export const FADE_OUT_DURATION_IN_SECONDS = 1;
export const FLOATING_BUTTON_DURATION_IN_SECONDS = 0.8;
export const TEXT_TRANSITION_DURATION_IN_SECONDS = 0.3;
export const FAB_DISAPPEAR_DURATION_IN_SECONDS = 2;

/* The native frame width as it was made by the designer. Intrinsic size of the png image. We agreed for a frame of 600px wide and 1000px tall */
export const NATIVE_ANIMATION_FRAME_WIDTH = 600;
